export default function zeroPaddedTime() {
    return function(time) {
        return ('0' + time).slice(-2);
    }
}